import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Layout from "./Layout";

const RootLayout = () => {
 const location = useLocation();
 const cmsAuth = useSelector((state) => state.cmsAuthenticator.cmsAuth || "");
  return (
    <Layout location={location} auth={cmsAuth}>
      <Outlet />
    </Layout>
  );
};

export default RootLayout;
